<template>
  <div class="count_down">
    <div class="item day day1"><div :class="['Number', `number_${~~(days/10)}`]"></div></div>
    <div class="item day day2"><div :class="['Number', `number_${~~days%10}`]"></div></div>
    <div class="item hour hour1"><div :class="['Number', `number_${~~(hours/10)}`]"></div></div>
    <div class="item hour hour2"><div :class="['Number', `number_${~~hours%10}`]"></div></div>
    <div class="item second second1"><div :class="['Number', `number_${~~(minitues/10)}`]"></div></div>
    <div class="item second second2"><div :class="['Number', `number_${~~minitues%10}`]"></div></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "ActivityCountDown",
  data() {
    return {
      days: "",
      hours: "",
      minitues: ""
    }
  },
  mounted() {
    this.setCountDownInterval()
  },
  computed: {
    ...mapGetters(["gameInfoConfigs"])
  },
  methods: {
    calCountDown() {
      let endTime = new Date(this.gameInfoConfigs.tuanConfig.activityEndTime).getTime()
      let now = new Date().getTime()
      let timediff = endTime - now
      this.minitues = Math.floor((timediff / 1000 / 60) % 60)
      this.minitues = this.minitues < 0 ? 0 : this.minitues
      this.hours = Math.floor((timediff / (1000 * 60 * 60)) % 24)
      this.hours = this.hours < 0 ? 0 : this.hours
      this.days = Math.floor(timediff / (1000 * 60 * 60 * 24))
      this.days = this.days < 0 ? 0 : this.days
    },

    setCountDownInterval() {
      this.calCountDown()
      setInterval(() => {
        this.calCountDown()
      }, 10000)
    }
  }
}
</script>
